import { Component, OnInit } from '@angular/core';

import { TipoPoder } from '../../../../models/tipo-poder.model';
import { CatalogosService } from '../../../../services/catalogos.service';

@Component({
  templateUrl: './post-registro-poderes.component.html',
  styleUrls: ['./post-registro-poderes.component.css'],
})
export class PostRegistroPoderesComponent implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Poderes (Trámites Post-Registro)',
      routerLink: '/post-registro/poderes',
    },
  ];

  tipos: TipoPoder[];
  loading = false;
  

  constructor(private catalogosService: CatalogosService) {}

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposPoderesPR().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
